import { Box, Typography } from "@mui/material";
import React, { memo } from "react";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { useTheme } from "@mui/system";

interface TotalStatsItemProps {
  title: string;
  value?: number;
  icon?: JSX.Element;
  noBorder?: boolean;
}

const TotalStatsItem = ({
  title,
  value,
  icon,
  noBorder,
}: TotalStatsItemProps) => {
  const theme = useTheme();
  const classes = {
    root: {
      borderRight: noBorder ? "unset" : "1px solid #ddd",
      flexGrow: 1,
      flexBasis: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
    },
    number: {
      fontSize: 23,
      fontWeight: 500,
      color: "var(--dmg-primary)",
    },
    title: {
      fontSize: 15,
      color: "#666",
      fontWeight: 400,
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        height: 40,
      },
    },
    infoWrapper: {
      display: "flex",
      alignItems: "center",
      margin: "0 10px",
      [theme.breakpoints.down("md")]: {
        justifyContent: "center",
        flexDirection: "column",
      },
    },
    iconWrapper: {
      padding: 1,
      marginRight: 2,
      borderRadius: "50%",
      background: "#efefef",
      width: 20,
      height: 20,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      opacity: 0.5,
      [theme.breakpoints.down("md")]: {
        marginRight: 0,
        marginBottom: 1,
      },
    },
  };

  return (
    <Box sx={classes.root}>
      <Box sx={classes.infoWrapper}>
        <Box sx={classes.iconWrapper}>{icon ?? <AccountBalanceIcon />}</Box>

        <Box display="flex" alignItems="center" flexDirection="column">
          <Typography sx={classes.title}>{title}</Typography>

          <Typography
            variant="h4"
            component="h2"
            sx={{
              color: "var(--dmg-primary)",
              fontWeight: 600,
              marginBottom: 1,
              fontSize: "20px",
            }}
          >
            {value?.toLocaleString("en-AU", { maximumFractionDigits: 0 })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(TotalStatsItem);
